export const selectLeaveTypes = (state) =>
  state.companyLeaveType?.leaveTypes || [];
export const selectLeaveTypeLoading = (state) =>
  state.companyLeaveType?.loading || false;
export const selectLeaveTypeError = (state) =>
  state.companyLeaveType?.error || null;
export const selectSelectedLeaveType = (state) =>
  state.companyLeaveType?.selectedLeaveType || null;
